import React from 'react'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Button } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import { useAppName } from 'commons/usePartner'

export default (props) => {
  const { open, setOpen, onSubmit } = props
  const appName = useAppName()
  return (
    <ResponsiveDialog
      isFullScreen={false}
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <FormattedMessage
          id="beacon.overview.dialog.interesting.title"
          values={{ appName }}
        />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <FormattedMessage id="beacon.overview.dialog.interesting.body" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="secondary"
          className="uppercase"
          variant="outlined"
        >
          <FormattedMessage id="beacon.overview.dialog.button.noThank" />
        </Button>
        <Button
          onClick={() => onSubmit()}
          variant="contained"
          color="secondary"
          className="uppercase"
        >
          <FormattedMessage id="beacon.overview.dialog.button.letMeknow" />
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
